import React from 'react';
import { Button } from '../../globalStyles';
import { GiCampingTent } from 'react-icons/gi';
import { FaBuilding, FaShoppingCart } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Project.elements';

function Project() {
  return (
    <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Major Projects</PricingHeading>
          <PricingContainer>
            <PricingCard href='https://www.github.com/rjptechsolutions' target="_blank" aria-label="Github">
              <PricingCardInfo>
                <PricingCardIcon>
                  <FaShoppingCart />
                </PricingCardIcon>
                <PricingCardPlan>RJ Store</PricingCardPlan>
                <PricingCardCost>$240</PricingCardCost>
                <PricingCardLength>a month</PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature>MERN Stack</PricingCardFeature>
                  <PricingCardFeature>Stripe & BrainTree Integration</PricingCardFeature>
                  <PricingCardFeature>Using MicroServices</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>More Details</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard href='https://www.github.com/rjptechsolutions' target="_blank" aria-label="Github">
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCampingTent />
                </PricingCardIcon>
                <PricingCardPlan>Travelgram </PricingCardPlan>
                <PricingCardCost>$150</PricingCardCost>
                <PricingCardLength>a month</PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature> JAM Stack </PricingCardFeature>
                  <PricingCardFeature>Angular 10</PricingCardFeature>
                  <PricingCardFeature>Firebase & GCP Cloud Storage </PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>More Details</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard href='https://www.github.com/rjptechsolutions' target="_blank" aria-label="Github">
              <PricingCardInfo>
                <PricingCardIcon>
                  <FaBuilding />
                </PricingCardIcon>
                <PricingCardPlan>Rohaan Developers</PricingCardPlan>
                <PricingCardCost>$105</PricingCardCost>
                <PricingCardLength>a month</PricingCardLength>
                <PricingCardFeatures>
                  <PricingCardFeature>Full Stack Django</PricingCardFeature>
                  <PricingCardFeature> Cloud PostgraceSQL</PricingCardFeature>
                  <PricingCardFeature>Deployed on Digital Ocean</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>More Details</Button>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}
export default Project;